import http from "./http";

export const getMeApi = () => http.get("/api/player/account/me");
